var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRight00Ff00(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6BB5\\u89C6\\u89D2\\u9875\\u9762",
    transform: "translate(-2050.000000, -1268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(2050.000000, 1268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4\\u5907\\u4EFD-6",
    fill: "#333333",
    stroke: "#F4F4F4",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 7.5,
    cy: 7.5,
    r: 6.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7BAD\\u5934(1)\\u5907\\u4EFD-4",
    transform: "translate(7.500000, 7.500000) rotate(90.000000) translate(-7.500000, -7.500000) translate(3.000000, 3.000000)",
    fill: "#6DD400",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97985075,4.5 C8.97985075,4.6141791 8.97985075,4.8358209 8.86567164,4.95 L8.07985075,5.7358209 L4.95,8.86567164 C4.8358209,8.97985075 4.6141791,8.97985075 4.5,8.97985075 C4.3858209,8.97985075 4.1641791,8.97985075 4.05,8.86567164 L3.2641791,8.07985075 C3.15,7.96567164 3.15,7.85820896 3.15,7.62985075 C3.15,7.51567164 3.2641791,7.29402985 3.2641791,7.17985075 L4.94328358,5.61492537 L0.57761194,5.61492537 C0.241791045,5.61492537 0.0201492537,5.39328358 0.0201492537,5.05746269 L0.0201492537,3.94253731 C0.0201492537,3.60671642 0.241791045,3.38507463 0.57761194,3.38507463 L4.94328358,3.38507463 L3.2641791,1.70597015 C3.15,1.59179104 3.15,1.48432836 3.15,1.37014925 C3.15,1.25597015 3.15,1.03432836 3.2641791,0.920149254 L4.05,0.134328358 C4.1641791,0.0201492537 4.3858209,0.0201492537 4.5,0.0201492537 C4.6141791,0.0201492537 4.8358209,0.0201492537 4.95,0.134328358 L8.08656716,3.27089552 L8.86567164,4.05 C8.97985075,4.1641791 8.97985075,4.3858209 8.97985075,4.5 Z",
    id: "\\u8DEF\\u5F84",
    transform: "translate(4.500000, 4.500000) rotate(-90.000000) translate(-4.500000, -4.500000) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight00Ff00);
export default __webpack_public_path__ + "static/media/right-00ff00.e36825e35b0bf7d63e6786e4d3d93696.svg";
export { ForwardRef as ReactComponent };